/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs */

const en_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live listings`)
};

const ar_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوائم مباشرة`)
};

const bn_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ লিস্টিং`)
};

const de_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Listings`)
};

const es_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios en vivo`)
};

const fr_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces en ligne`)
};

const pt_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios no ar`)
};

const zh_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线上 listing`)
};

const tr_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı listelemeler`)
};

const ru_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Живые листинги`)
};

const pl_svc_ai_image_pod_automation_execute_output7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żywe listingi`)
};

/**
* | output |
* | --- |
* | "Live listings" |
*
* @param {Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_execute_output7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_execute_output7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_execute_output7(inputs)
	return en_svc_ai_image_pod_automation_execute_output7(inputs)
});
export { svc_ai_image_pod_automation_execute_output7 as "svc_ai-image-pod-automation_EXECUTE_output" }